<template>
  <div style="width: 260px; height: 100%; overflow-y: auto;">
    <RecycleScroller :items="agents" :item-size="258" key-field="uid" v-slot="{ item }">
      <the-agent-card :agent="item" :stats="false" :show-status="true" :show-actions="false" class="agent"></the-agent-card>
    </RecycleScroller>
</div>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller'
import { mapGetters } from 'vuex';
import TheAgentCard from '@/components/dashboard/TheAgentCard';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
export default {
    name : "AgentDashboard",
    computed : {
      ...mapGetters({
        tmpagents : 'getAgentsDashboard',
        agent : 'getAgent',
      }),
      agents() {
        return this.tmpagents
          .filter(agent => agent.number !== undefined && agent.number != this.agent.number)
          .filter(agent => agent.call_logged || agent.chat_logged)
      }
    },
    components : {
      TheAgentCard,
      RecycleScroller,
    },
    created() {
      this.$store.dispatch('listenAgentsDashboard', this.agent.organization_id);
    }
}
</script>

<style scoped>
/* .agent-dashboard {
  height: 90vh;
  overflow-y: auto;
}

.agent-card {
  margin-bottom: var(--column);
  width: 200px;
}


.agent {
  margin-bottom: var(--column);
  width: 257px;
} */

.agent-card >>> i {
  font-size: 20px;
}
</style>